export default __webpack_public_path__ + "static/media/icon-activity-liked.4fdac1ea.svg";